import * as types from "../actions/types";
import { SharedApi } from "../api/sharedAPI";

export function loadUserSuccess(userProps) {
  
  return { type: types.LOAD_USER_SUCCESS, userProps };
}

export function loadUserFailure(userProps) {
  
  return { type: types.LOAD_USER_FAILURE, userProps };
}

/*
export function loadUser() {
  //console.log('calling loadUser()')
  return function (dispatch) {
    return SharedApi.getUserProperties()
      .then((userProps) => {

        dispatch(loadUserSuccess(userProps));

        if (userProps.user.role === "Admin") return;
        else if (userProps.user.role === "Principal") return;
        else if (userProps.user.role === "Campus") return;
    
    
      })
      .catch((error) => {
        throw error;
      });
  };
}
  */


export const getPrimaryRole = (roles) => {
    if (!Array.isArray(roles)) return "Unassigned";

    if (roles.includes("ASKIT_Admin") || roles.includes("Admin")) return "Admin";
    if (roles.includes("ASKIT_News") || roles.includes("Admin")) return "ASKIT_News";
   
    return "Unassigned";
};

export const loadUser = () => async (dispatch) => {
    try {
        const data = await SharedApi.getUserProperties();

        if (data.isAuthenticated && data.user) {
            const { user } = data;
            const roles = user.roles || [];
            console.log("Roles Array from Azure API:", roles);

            // Use the helper to get the single string 'role'
            const primaryRole = getPrimaryRole(roles);
            console.log("Primary Role Determined:", primaryRole);

            const userWithRoles = {
                ...user,
                role: primaryRole, // state.userProps.role
                roles: roles,      // state.userProps.roles (the full array)
                
                // Keep your booleans for easy UI toggles
                isAdmin: roles.includes("ASKIT_Admin") || roles.includes("Admin"),
                //isTeacher: roles.includes("Crosswalk_Teacher") || roles.includes("Teacher"),
                isUnassigned: roles.length === 0
            };

            dispatch(loadUserSuccess(userWithRoles));
        } else {
            dispatch(loadUserFailure("User not authenticated"));
        }
    } catch (error) {
        dispatch(loadUserFailure(error.message));
    }
};




export function loadCustomUser(userID) {
  return function (dispatch) {
    return SharedApi.getCustomUserProperties(userID)
      .then((userProps) => {
        //console.log(userProps);
        dispatch(loadUserSuccess(userProps));
          if (userProps.user.role === "Admin") return;
        else if (userProps.user.role === "Principal") return;
        else if (userProps.user.role === "Campus") return;
      })
      .catch((error) => {
        throw error;
      });
  };
}

/*AZURE ***** THIS BYPASSES AUTHENTICATION */
export function loadUserNoAuth() {
  return function (dispatch) {
    return SharedApi.getMockUserProperties()
      .then((userProps) => {
        dispatch(loadUserSuccess(userProps));
        
        if (userProps.user.role === "Admin") return;
        else if (userProps.user.role === "Principal") return;
        else if (userProps.user.role === "Campus") return;
        else if (userProps.user.role === "Crosswalk_Division_North") return;
        else if (userProps.user.role === "Crosswalk_Division_South") return;
        else if (userProps.user.role === "Crosswalk_Division_West") return;
        else if (userProps.user.role === "Crosswalk_Division_Central") return;
        else if (userProps.user.role === "Crosswalk_View Only_User") return;
        else if (userProps.user.role === "Crosswalk_Campus_User") return;
      })
      .catch((error) => {
        throw error;
      });
  };
}


